(function() {

    /* globals app, api */

    'use strict';

    var importArea = document.querySelectorAll('textarea[data-import]');

    app.addEventListener(importArea, 'keydown', function(e) {

        if (!(e.keyCode === 13 && e.altKey)) {
            return;
        }

        if (!app.isJSON(this.value)) {
            return;
        }

        var formData = new FormData(),
            url = document.URL;

        formData.append(this.dataset.import, this.value);

        this.value = '';

        api.post(url.substring(0, url.lastIndexOf('/')) + '/' + this.dataset.import + '/import', formData, {}).then(function (response) {

            response.text().then(function(content) {

                var script = document.createElement('script');
                script.text = content;

                document.head.appendChild(script).parentNode.removeChild(script);

            });

        });

    });

    app.addEventListener(importArea, 'dragenter', function(e) {
       e.preventDefault();
    });

    app.addEventListener(importArea, 'drop', function(e) {

        e.preventDefault();

        var self = this,
            data = e.dataTransfer;

        if(data === null) {
            return;
        }

        var handleDrop = function (e) {

            var data = app.isJSON(e.target.result);

            if (!data) {
                return;
            }

            self.value = JSON.stringify(data, null, 2);
            self.style.height = self.scrollHeight + 'px';

        };

        for(var i=0;i < data.files.length;i++) {

            var file = data.files[i];

            if(file.type !== 'application/json') {
                continue;
            }

            var reader = new FileReader();

            reader.onload = handleDrop;

            reader.readAsText(file);

        }

    });


}());